import { Component, inject, Injector, OnInit } from '@angular/core';
import { ObjectGroupViewModel } from "../../ObjectGroupViewModel";
import { IManagableObject } from "../../IManagableObject";
import { Observable } from "rxjs";
import { GroupBaseAdminPanelComponent } from "../../base-admin-panel/group-base-admin-panel.component";
import { CreateObjectsComponent } from "../create-objects.component";
import { EditObjectsComponent } from "../edit-objects.component";
import { ObjectsService } from "../../../../services/objects.service";
import { ObjectKeysSyncDialogComponent } from "../../Keys/objectkeys-sync-dialog/objectkeys-sync-dialog.component";
import { ObjectFilterType, ObjectsFilterModel } from "../../../shared/pipes/FilterObjects.pipe";
import { FilterData } from "../../../shared/components/objects-filter/objects-filter.component"
import { ObjectIconDialogComponent } from '../object-icon-dialog/object-icon-dialog.component';
import { ObjectModel } from "../../../../models/ObjectModel";
import { IconViewModel } from "../../../../models/IconViewModel";
import { CompanyModel } from 'app/services/companies.service';
import { ObjectImportResult } from "../../../../models/ObjectImportResult";
import { ObjectStatus } from "../../../../models/ObjectStatusEnum";
import { ObjectsImportDialogComponent } from "../objects-import-dialog/objects-import-dialog.component";
import { ObjectImportModel } from "../Models/ObjectImportModel";
import { ObjectLiteViewModel } from 'app/models/ObjectLiteViewModel';
import { AccessRights } from 'app/services/users.service';
import { ErrorReplyWithArgs } from 'app/models/ErrorModels';

@Component({
  selector: '[app-objects]',
  templateUrl: './objects.component.html',
  styleUrls: ['./objects.component.css'],
  standalone: false
})
export class ObjectsComponentComponent extends GroupBaseAdminPanelComponent implements OnInit {

  public extendedFilter: ObjectsFilterModel = new ObjectsFilterModel();
  private objectsService: ObjectsService;
  protected readonly ObjectStatus = ObjectStatus;

  public users: IManagableObject[] = [];
  private companies: CompanyModel[];
  canAdd: boolean = false;

  constructor(protected injector: Injector) {
    super(injector);
    this.objectsService = injector.get(ObjectsService);
    this.companyService.getCompanies().subscribe((res) => {
      this.companies = res;
    });
    //this.keysService = injector.get(KeysService);
    this.groupName = "ObjectsGroup";
    this.entityName = "Object";

    this.canAdd = this.usersService.getCurrentUser().CanDo(AccessRights.EDIT_TRACKERS_IMEI);
  }

  public GetUserName(id) {
    for (var i = 0; i < this.users.length; i++)
      if (this.users[i].Id == id)
        return this.users[i].Name;
    return "";
  }
  public GetCompanyName(id) {
    if (this.companies)
      return this.companies.find(x => x.Id == id)?.Name ?? "";
    return "";
  }

  public selectGroup(group: ObjectGroupViewModel) {
    super.selectGroup(group);
    this.extendedFilter.group = group;
  }

  public onExtendedTermChange(data: FilterData) {
    this.extendedFilter.term = data.searchFilter;
    this.extendedFilter.filterType = data.searchType;
  }

  getObjects(): ObjectLiteViewModel[] {
    return this.objects as ObjectLiteViewModel[];
  }

  protected Refresh() {
    this.objectsService.GetLiteObjects()
      .subscribe((objects: any[]) => {
        this.objectsService.GetIcons()
          .subscribe((icons: IconViewModel[]) => {
            objects.forEach(o => {
              o.Icon = icons.filter(i => i.Id == o.IconId)[0];
            })
          })

        this.objects = objects;
      });
    this.objectsService.GetObjectGroups()
      .subscribe(groups => {
        this.groupFilter.groups = groups;
      });
    this.usersService.getUsersStatistics()
      .subscribe(users => {
        this.users = users;
      });
  }

  protected doCreateGroup(input: IManagableObject): Observable<any> {
    return this.objectsService.CreateGroup(input);
  }

  protected doDeleteGroup(input: IManagableObject): Observable<any> {
    return this.objectsService.DeleteGroup(input);
  }

  protected doDeleteObject(id: number): Observable<any> {
    return this.objectsService.DeleteObject(id);
  }
  protected override doDeleteObjects(ids: number[]): Observable<any> {
    return this.objectsService.DeleteObjects(ids);
  }

  protected onDeletingObjects(ids: number[]) {
    ids.forEach(id => {
      let obj: ObjectModel = <ObjectModel>this.objects.find(x => x.Id == id);
      if (obj.Status != ObjectStatus.Deleted)
        obj.Status = ObjectStatus.Deleted;
      else
        this.objects = this.objects.filter(x => x.Id != id);
    })
  }

  public openCreateModal() {
    this.prepareModal(CreateObjectsComponent);
    this.componentRef.instance.open(new ObjectModel());
  }

  public createDuplicate(object: ObjectModel) {
    this.objectsService.GetObject(object.Id)
      .subscribe(object => {
        let clone: ObjectModel = Object.assign(new ObjectModel(), object);
        clone.IMEI = undefined;
        clone.Name = "";
        clone.Id = 0;
        clone.ServiceLogs = [];
        clone.PayedTill = 0;
        for (let i = 0; i < clone.Sensors.length; i++)
          clone.Sensors[i].Id = 0;

        this.openCreateModelPrivate(clone);
      });
  }

  public openEditModal(object: ObjectModel) {
    this.objectsService.GetObject(object.Id)
      .subscribe(object => {
        this.objectsService.GetIcons()
          .subscribe((icons: IconViewModel[]) => {
            this.objectsService.GetOdometer(object.Id)
              .subscribe(odometer => {
                object.Icon = icons.find(i => i.Id == object.IconId);
                object.Odometer = odometer;
                this.openEditModelPrivate(object);
              })
          })
      });
  }

  private openEditModelPrivate(object) {
    this.prepareModal(EditObjectsComponent);
    this.componentRef.instance.open(object);
  }

  private openCreateModelPrivate(object: ObjectModel) {
    this.prepareModal(CreateObjectsComponent);
    this.componentRef.instance.open(object);
  }

  openSyncKeysDialog(obj: ObjectModel) {
    this.prepareModal(ObjectKeysSyncDialogComponent);
    this.componentRef.instance.objectId = obj.Id;
    this.componentRef.instance.open();
  }

  openSetIconDialog() {

    let entities = this.objects.filter(c => c.IsChecked);
    if (entities.length) {
      this.prepareModal(ObjectIconDialogComponent);
      this.componentRef.instance.objectsArr = entities;
      this.componentRef.instance.open();
    }
  }

  openImportObjectsDialog() {
    this.prepareModal(ObjectsImportDialogComponent);
    this.componentRef.instance.open(new ObjectImportModel());
    this.Refresh();
  }

  exportJsonFile(): void {
    let ids = this.objects.filter(x => x.IsChecked).map(x => x.Id);
    if (ids.length > 0) {
      const exportSuccessMsg = this.translate.instant("Export successful");
      const exportFailedMsg = this.translate.instant("Export failed");
      this.objectsService.exportJson(ids).subscribe((blob: Blob) => {
        const a = document.createElement('a');
        const objectUrl = URL.createObjectURL(blob);
        a.href = objectUrl;
        a.download = `export_${new Date().toISOString().replace(/[:.]/g, '-')}.json`;
        a.click();
        URL.revokeObjectURL(objectUrl);
        this.toastr.success(exportSuccessMsg);
      }, (error: ErrorReplyWithArgs) => {
        // this.toastr.error(exportFailedMsg);
        this.toastr.error(this.translate.instant(error.reply, { 0: error.args }));
      });
    } else {
      const infoMsg = this.translate.instant("Choose objects to export");
      this.toastr.info(infoMsg);
    }
  }

  public getStatusName(status: ObjectStatus): string {
    switch (status) {
      case ObjectStatus.NotInstalled:
        return this.translate.instant("Not installed");
      case ObjectStatus.OnService:
        return this.translate.instant("In service");
      default:
        return ObjectStatus[status]
    }
  }
}

